import React, { FC } from 'react';

import { Done } from '@mui/icons-material';
import { Alert, AlertTitle, Box } from '@mui/material';

import { CheckPromoResult } from '~/services/PromoService';

import Spinner from '../Common/Spinner';

interface PromoCheckStatusProps {
  isCheckLoading?: boolean;
  promoCheckStatus: CheckPromoResult | null;
}

const PromoCheckStatus: FC<PromoCheckStatusProps> = ({ isCheckLoading, promoCheckStatus }) => {
  if (!promoCheckStatus) {
    return null;
  }

  if (isCheckLoading) {
    return <Spinner />;
  }

  return (
    <Box>
      {promoCheckStatus.status === 'non-existent' && (
        <Box title="Promo code name is unused">
          <Done />
        </Box>
      )}
      {promoCheckStatus.status !== 'non-existent' && (
        <Alert severity="error">
          <AlertTitle>{promoCheckStatus.status}</AlertTitle>
          {JSON.stringify(promoCheckStatus, null, 2)}
        </Alert>
      )}
    </Box>
  );
};

export default PromoCheckStatus;
